import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
// 导入 Vant 3 及其样式
import Vant from 'vant'
import 'vant/lib/index.css'

import App from './App.vue'
import router from './router'
// 导入axios配置
import './utils/axios'

// 获取环境变量
const env = import.meta.env

// 在开发环境下可以考虑添加vconsole进行调试
if (env.VITE_DEBUG === 'true') {
  import('vconsole').then((VConsole) => {
    new VConsole.default()
  })
}

const app = createApp(App)

// 根据环境设置开发工具
app.config.devtools = env.VITE_APP_ENV === 'development'

// 全局注入环境变量
app.config.globalProperties.$env = env

// 使用 Vant 插件（Vant 3 为 Vue 3 优化的版本）
app.use(Vant)
app.use(createPinia())
app.use(router)

app.mount('#app')
